import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Box, Collapse, FormControlLabel, List, ListItemButton, ListItemText, Menu, MenuItem, Switch} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Logo from "../../images/logo.webp";
import {menuList} from "../../router/menuList";

export default function Menus(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultState = menuList.map((menu) => (
      {[menu.id]: menu.children.map(child => child[1]).flat().includes(location.pathname)}
    ))[0];
  const [expanded, setExpanded] = React.useState(defaultState || {});
  const [anchor, setAnchor] = React.useState(null);
  const closeMenuNavigate = (route, selectedFg) => {
    if (!selectedFg) {
      const token = sessionStorage.getItem("xCsrfToken");
      const cp = sessionStorage.getItem("cpCd");
      const no = sessionStorage.getItem("stffNo");
      const name = sessionStorage.getItem("stffNm");
      const admin = sessionStorage.getItem("adminFg");
      sessionStorage.clear();
      sessionStorage.setItem("xCsrfToken", token);
      sessionStorage.setItem("cpCd", cp);
      sessionStorage.setItem("stffNo", no);
      sessionStorage.setItem("stffNm", name);
      sessionStorage.setItem("adminFg", admin);
    };
    document.getElementById("hamburger_btn").click();
    navigate(route);
  };
  const toggleExpanded = (id) => {
    setExpanded(prevState => ({...prevState, [id]: !prevState[id]}))
  };
  const openFooterMenu = (e) => {
    setAnchor(e.currentTarget);
  };
  const closeFooterMenu = (route) => {
    setAnchor(null);
    if (route) {
      closeMenuNavigate(route);
    }
  };
  const changeFontSize = (e) => {
    props.setLgFontFg(e.target.checked);
    sessionStorage.setItem("lgFontFg", e.target.checked ? "1" : null);
  }

  return (
    <Box
      className = "menu"
      sx = {{minHeight: "100vh", display: "flex", flexDirection: "column"}}
    >
      <Box
        alt = "logo"
        className = "menu-logo"
        component = "img"
        src = {Logo}
      />
      <List
        component = "nav"
        sx = {{mb: "auto"}}
      >
        {/* <ListItemButton
          onClick = {() => closeMenuNavigate("/home")}
          selected = {location.pathname === "/home"}
        >
          <ListItemText
            primary = "HOME"
          />
        </ListItemButton> */}
        {menuList.map((menu) => (
          <Box
            key = {menu.id}
          >
            <ListItemButton
              onClick = {() => toggleExpanded(menu.id)}
            >
              <ListItemText
                primary = {menu.primary}
              />
              {expanded[menu.id] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
              in = {expanded[menu.id]}
              unmountOnExit
            >
              <List
                component = "div"
                disablePadding
              >
                {menu.children.map((child) => (
                  (!Boolean(child[2]) || Boolean(sessionStorage.getItem(child[2]))) &&
                  <ListItemButton
                    key = {child[1][0]}
                    onClick = {() => closeMenuNavigate(child[1][0], child[1].includes(location.pathname))}
                    selected = {child[1].includes(location.pathname)}
                    sx = {{ pl: 4 }}
                  >
                    <ListItemText primary={child[0]} />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          </Box>
        ))}
        {/* <ListItemButton
          disabled
          onClick = {() => closeMenuNavigate("/change_jg")}
          selected = {location.pathname === "/change_jg"}
        >
          <ListItemText
            primary = "事業所切替"
          />
        </ListItemButton> */}
        <FormControlLabel
          control = {
            <Switch
              checked = {props.lgFontFg}
              onChange = {(e) => changeFontSize(e)}
            />
          }
          label = "文字拡大"
          labelPlacement = "start"
        />
      </List>
      <Box
        bottom = {0}
        position = "sticky"
        sx = {{zIndex: 1}}
      >
        <ListItemButton
          aria-controls = {Boolean(anchor) ? "menu_footer_more_list" : undefined}
          aria-expanded = {Boolean(anchor) ? "true" : undefined}
          aria-haspopup = "true"
          id = "menu_footer"
          onClick = {openFooterMenu}
        >
          <ListItemText primary = {sessionStorage.getItem("stffNm") + "さん"} />
          <MoreVertIcon />
        </ListItemButton>
        <Menu
          anchorEl = {anchor}
          anchorOrigin = {{vertical: "top", horizontal: "right",}}
          id = "menu_footer_more_list"
          onClose = {() => closeFooterMenu(null)}
          open = {Boolean(anchor)}
          transformOrigin = {{vertical: "bottom", horizontal: "right"}}
        >
          {/* <MenuItem
            onClick = {() => closeFooterMenu("/")}
          >
            ユーザ情報
          </MenuItem> */}
          <MenuItem
            onClick = {() => closeFooterMenu("/")}
          >
            ログアウト
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
};
